import { message as alertMessage } from "ant-design-vue";

import { AxiosClient } from "../../utils/axios";
import { sleep } from "../../utils/common";
import { logError } from "../../utils/logError";
export const state = () => ({
  schoolId: "",
  schoolAccountInfo: {},
  listMajor: [],

  userRole: "",
  listNews: [],
  schoolAccountLoading: false,
  listEvents: [],
  filePath: null,
});

export const mutations = {
  SET_LOADING(state, payload) {
    state.schoolAccountLoading = payload;
  },
  SET_USER_ROLE(state, { school_id, table }) {
    state.schoolId = school_id || "";
    state.userRole = table || "";
  },
  SET_LIST_MAJOR_OF_SCHOOL(state, payload) {
    state.listMajor = payload;
  },

  SET_LIST_NEWS(state, payload) {
    state.listNews = payload;
  },
  ADD_NEWS(state, payload) {
    if (!payload) return;
    state.listNews.unshift(payload);
  },
  REMOVE_NEWS(state, payload) {
    state.listNews = state.listNews.filter(({ id }) => id !== payload);
  },
  UPDATE_NEWS(state, payload) {
    state.listNews = state.listNews.map(({ id, ...rest }) =>
      id == payload.id ? { id, ...rest, link: payload.link } : { id, ...rest }
    );
  },
  SET_LIST_EVENTS(state, payload) {
    state.listEvents = payload;
  },
  SET_PATH(state, payload) {
    state.filePath = payload;
  },
};

export const actions = {
  async getUserRole({ commit }, { memberId,isServer }) {

    commit("SET_LOADING", true);

    if(isServer && isServer==true){
      AxiosClient.defaults.baseURL = 'http://localhost:3000'
    }
    try {
      const res = await AxiosClient.get(
        `/eduzone/api/school-account/get-user-role?memberId=${memberId}`,
      );

      commit("SET_USER_ROLE", res.data);
      commit("SET_LOADING", false);
      return res;
    } catch (error) {
      logError(error, "getUserRole on store");
      commit("SET_USER_ROLE", {});
      commit("SET_LOADING", false);
 
    }
   
  },

  async getListMajorOfSchool(store) {
    store.commit("SET_LOADING", true);
   
    const { schoolId } = store.state;
    try {
      const res = await AxiosClient.get(
        `/eduzone/api/school-account/get-list-major-of-school?schoolId=${schoolId}`,
     
      );
      const { code, data } = res.data;
      if (code == 200) {
        // console.log({ data });
        // const listMajor = data.map((item, index) => {
        //   return {
        //     ...item,
        //     key: index,
        //     specialty: {
        //       name: item.major_name,
        //       code: item.majors_id,
        //     },
        //   };
        // });
        // console.log(listMajor);
        store.commit("SET_LIST_MAJOR_OF_SCHOOL", data);
      }
    } catch (error) {
      logError(error, "getListMajorOfSchool on store");
    }
    store.commit("SET_LOADING", false);
  },

  async getAllLinkOfSchool(store) {
  
    store.commit("SET_LOADING", true);
    const { schoolId } = store.state;
    try {
      const res = await AxiosClient.get(
        `/eduzone/api/school-account/get-list-news-of-school?schoolId=${schoolId}`,
      
      );
      const { code, data } = res.data;
      if (code == 200) {
        store.commit("SET_LIST_NEWS", data);
      }
    } catch (error) {
      logError(error, "getAllLinkOfSchool on store");
    }
    store.commit("SET_LOADING", false);
  },
  async addNewLink(store, { memberId, url }) {
   
    store.commit("SET_LOADING", true);
    const { schoolId } = store.state;
    try {
      const res = await AxiosClient.post(
        `/eduzone/api/school-account/add-new-link`,
        {
          memberId,
          school_id: schoolId,
          link: url,
        },
     
      );
      const { code, data } = res.data;
      if (code == 200) {
        // store.dispatch("getAllLinkOfSchool");
        
        // const { id, link } = data;
        await sleep(1000);
        await store.dispatch("getAllLinkOfSchool");
        alertMessage.success("Thêm tin tức thành công");
        // store.commit("ADD_NEWS", { id, link });
      }
    } catch (error) {
      console.log(error);
    }
    store.commit("SET_LOADING", false);
  },
  async updateNewsOfSchool(store, { memberId, link, id }) {

    store.commit("SET_LOADING", true);
    const { schoolId } = store.state;
    try {
      const res = await AxiosClient.put(
        `/eduzone/api/school-account/update-news-of-school?id=${id}&memberId=${memberId}`,
        { school_id: schoolId, link },
       
      );
      const { code, data } = res.data;
      if (code == 200) {
        alertMessage.success("Cập nhật tin tức thành công");
        store.commit("UPDATE_NEWS", data);

        // store.dispatch("getAllLinkOfSchool");
      }
    } catch (error) {
      console.log(error);
    }
    store.commit("SET_LOADING", false);
  },

  async deleteNewsOfSchool(store, { memberId, newsId }) {
  
    const schoolId = Number(store.rootState.SchoolAccount.schoolId);
    // console.log("id", schoolId);
    store.commit("SET_LOADING", true);
    try {
      const res = await AxiosClient.delete(
        `/eduzone/api/school-account/delete-news-of-school?id=${newsId}&memberId=${memberId}`,
        {
          data: { school_id: schoolId },
       
        }
      );
      // console.log("log ré", res);
      const { code, data } = res.data;
      if (code == 200) {
        alertMessage.success("Xóa tin tức thành công");
        store.commit("REMOVE_NEWS", newsId);
      }
    } catch (error) {
      console.log(error);
    }
    store.commit("SET_LOADING", false);
  },
  async editAwardVideo(store, { id, memberId, data,handleType }) {
 
    try {
      const res = await AxiosClient.put(
        `/eduzone/api/school-account/editvideoaward?id=${id}&memberId=${memberId}`,
        data,
     
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        const convertToObj = res.data.data;
        // console.log("data", convertToObj);
        store.commit("SchoolDetail/SCHOOL_OUTSTANDING", convertToObj, {
          root: true,
        });
        // .then(() => alertMessage.success("Chỉnh sửa thành công"))
        // .catch((err) => console.log(err));
        if(handleType=='add'){
          alertMessage.success("Thêm  thành công");
        }else if(handleType=='delete'){
          alertMessage.success("Xóa thành công");
        }else{

          alertMessage.success("Chỉnh sửa thành công");
        }
      }
    } catch (error) {
      console.log(error);
    }
  },
  async uploadAwardVideo({ state, dispatch, rootState }, payload) {
 
    try {
      const res = await AxiosClient.post(
        `/eduzone/api/school-account/uploadVideoAward?memberId=${payload.memberId}`,
        payload,
     
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        const convertToObj = res.data.data;
        // console.log("data", convertToObj);

       await sleep(500);
      await dispatch("SchoolDetail/getSchoolOutstanding", state.schoolId, {
        root: true,
      });
        // .then(() => alertMessage.success("Chỉnh sửa thành công"))
        // .catch((err) => console.log(err));
        alertMessage.success("Tải video lên thành công");
      }
    } catch (error) {
      console.log(error);
    }
  },
  async uploadResource({ commit, rootState }, { file }) {

    try {
      let data = new FormData();
      data.append("files", file);
     
      const res = await AxiosClient.post("/eduzone/api/school-account/upload", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      });

      commit("SET_PATH", res.data.data.files[0]);
    } catch (error) {
      console.log(error);
    }
  },
  async uploadMultiResource({ commit, rootState }, data) {

    try {
      const res = await AxiosClient.post("/eduzone/api/school-account/uploads", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        
        },
      });
      return res.data;
    } catch (error) {
      console.log(error);
    }
  },
  async updateSchoolOverView({ commit, rootState }, { id, memberId, data }) {
    
    try {
      const res = await AxiosClient.put(
        `/eduzone/api/school-account/updateforschoolsaccount/?id=${id}&&memberId=${memberId}`,
        data,
       
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        // .then(() => alertMessage.success("Chỉnh sửa thành công"))
        // .catch((err) => console.log(err));
        alertMessage.success("Chỉnh sửa thành công");
      }
    } catch (error) {
      console.log(error);
    }
  },
  async addSchoolStaff({ commit, rootState }, payload) {
   
    try {
      const res = await AxiosClient.post(
        `/eduzone/api/school-account/add-staff`,
        payload,
       
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        alertMessage.success("Thêm nhân sự thành công");
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  },
  async editSchoolStaff({ commit, rootState }, payload) {
   
    try {
      const res = await AxiosClient.put(
        `/eduzone/api/school-account/edit-staff`,
        payload,
     
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        alertMessage.success("Sửa nhân sự thành công");
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  },
  async deleteSchoolStaff({ commit, rootState }, payload) {
    const {staff_id,member_id,school_id} = payload
    try {
    
      const res = await AxiosClient.delete(
        `/eduzone/api/school-account/delete-staff/${staff_id}/${member_id}/${school_id}`,
      
      );

      if (res.data.code == 200 && res.data && res.data.data) {
        alertMessage.success("Xoá nhân sự thành công");
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  },

  // -------------------------------------------
  async addSchoolMajor({ commit, dispatch, rootState }, payload) {

    try {
      const res = await AxiosClient.post(
        `/eduzone/api/school-account/add-major`,
        payload,
      
      );
      // console.log({ res: res.data });
      if (res.data.code == 200 && res.data) {
        await sleep(1000);
        await dispatch("getListMajorOfSchool");
        alertMessage.success("Thêm ngành thành công");
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  },

  async getSchoolMajors({ commit, rootState }, payload) {
  
    try {
      const res = await AxiosClient.get(
        `/eduzone/api/school-account/get-majors?id=${payload}`,
     
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  },

  async editSchoolMajor({ commit, dispatch, rootState }, payload) {
    try {
 
      const { id, member_id } = payload;
      delete payload.id;
      delete payload.member_id;
      const res = await AxiosClient.put(
        `/eduzone/api/school-account/edit-major?id=${id}&member_id=${member_id}`,
        payload,
    
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        await sleep(1000);
        await dispatch("getListMajorOfSchool");
        alertMessage.success("Chỉnh sửa ngành thành công");
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  },

  async deleteSchoolMajor({ commit, dispatch, rootState }, payload) {
    
    try {
      const{id,member_id,school_id} = payload
      const res = await AxiosClient.delete(
        `/eduzone/api/school-account/delete-major/${id}/${member_id}/${school_id}`,
      
      );

      if (res.data.code == 200 && res.data) {
        
       await sleep(1000);
      await dispatch("getListMajorOfSchool");
         
          alertMessage.success("Xoá ngành thành công");
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  },

  async addSchoolLink({ commit, rootState }, payload) {
 
    try {
      const { member_id } = payload;
      delete payload.member_id;
      const res = await AxiosClient.post(
        `/eduzone/api/school-account/add-link/${member_id}`,
        payload,
     
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        alertMessage.success("Thêm tin tức thành công");
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  },

  async editSchoolLink({ commit, rootState }, payload) {
    
    try {
      const { id, member_id } = payload;
      delete payload.id;
      delete payload.member_id;
      const res = await AxiosClient.put(
        `/eduzone/api/school-account/edit-link?id=${id}&member_id=${member_id}`,
        payload,
      
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        alertMessage.success("Sửa thành công");
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  },

  async deleteSchoolLink({ commit, rootState }, payload) {

    try {
      const { member_id, id } = payload;
      const res = await AxiosClient.delete(
        `/eduzone/api/school-account/delete-link/?member_id=${member_id}&id=${id}`,
      
      );

      if (res.data.code == 200 && res.data && res.data.data) {
        alertMessage.success("Xoá tin tức thành công");
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  },

  async addSchoolEvent({ commit, rootState }, payload) {
  
    try {
      const { member_id } = payload;
      delete payload.member_id;
      const res = await AxiosClient.post(
        `/eduzone/api/school-account/add-event?member_id=${member_id}`,
        payload,
       
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        alertMessage.success("Thêm sự kiện thành công");
        return res.data;
      }
    } catch (error) {
      console.log("addSchoolEvent store error", error);
    }
  },

  async getSchoolEvents({ commit, rootState }, payload) {
 
    try {
      const { page_size, page, school_id } = payload;

      const res = await AxiosClient.get(
        `/eduzone/api/school-account/get-events?school_id=${school_id}&page_size=${page_size}&page=${page}`,
    
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        return res.data;
      }
    } catch (error) {
      console.log("getSchoolEvents store error", error);
    }
  },
  async editSchoolEvent({ commit, rootState }, payload) {

    try {
      const { member_id, id } = payload;
      delete payload.member_id;
      delete payload.id;
      const res = await AxiosClient.put(
        `/eduzone/api/school-account/edit-event?member_id=${member_id}&id=${id}`,
        payload,
      
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        alertMessage.success("Sửa thành công");
        return res.data;
      }
    } catch (error) {
      console.log("editSchoolEvent store error", error);
    }
  },
  async deleteSchoolEvent({ commit, rootState }, payload) {

    try {
      const { member_id, id,school_id } = payload;

      const res = await AxiosClient.delete(
        `/eduzone/api/school-account/delete-event?member_id=${member_id}&id=${id}&school_id=${school_id}`,
      
      );
      if (res.data.code == 200 && res.data && res.data.data) {
        alertMessage.success("Xoá thành công");
        return res.data;
      }else{
        return res
      }
    } catch (error) {
      console.log("[deleteSchoolEvent] store error", error);
    }
  },

  async createCensorShip({ commit, rootState }, payload) {
   
    try {
 
      const response = await AxiosClient.post(
        "/eduzone/api/school-account/create-censorship",
        payload
     
      );
      
    } catch (error) {
      console.log("[createCensorShip] store error", error);
    }
  },
};
